import { render, staticRenderFns } from "./BookingTemplateItemDimensionEdit.vue?vue&type=template&id=7d61366d&scoped=true&"
import script from "./BookingTemplateItemDimensionEdit.vue?vue&type=script&lang=ts&"
export * from "./BookingTemplateItemDimensionEdit.vue?vue&type=script&lang=ts&"
import style0 from "./BookingTemplateItemDimensionEdit.vue?vue&type=style&index=0&id=7d61366d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d61366d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon,VSpacer,VTab,VTabItem,VTextField})
